import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <CarouselSection />
        <CardsSection />
        <IndexSection />
        <MediaSection />
        <FeaturesSection />
        <AppSection />
        <RankingSection />
        <CommentsSection />
        <FaqSection />
        <UpdatesSection />
        <AboutSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}